import React from 'react';

import { TodaysApptUserFlowSteps } from 'features/order-tracker/pages/order-summary/components/SnapshotCardSection/constants';
import { ExternalLink } from 'features/order-tracker/shared-components';
import { InfoIcon } from 'features/order-tracker/shared-components/svg';
import { APPT_USER_PATH_STEP_STORAGE_NAME } from 'features/order-tracker/store/hooks/contstants';

import { DATA_INFO } from './constants';

import styles from './styles.module.scss';

export const TodaysAppointmentCardContent: React.FC<components.TodaysAppointmentCardContent> = ({ formattedDate }) => {
  const storedStepIndex =
    parseInt(localStorage.getItem(APPT_USER_PATH_STEP_STORAGE_NAME)!, 10) || TodaysApptUserFlowSteps.Init;
  const { paragraph1, paragraph2, paragraph3, paragraph4 } = DATA_INFO[storedStepIndex];
  const slot = formattedDate.split('between')[1];
  const endTime = slot.split(' and ')[1];

  return (
    <div className={styles.todaysApptInfoContainer}>
      {paragraph1 && (
        <>
          <div className={styles.header}>
            <InfoIcon />
            <h5>{paragraph1.title}</h5>
          </div>
          <p>
            {paragraph1.messages[0]}
            {paragraph1.withDynamicData && (
              <>
                <strong>{formattedDate}</strong>
                {paragraph1.messages[1]}
              </>
            )}
          </p>
        </>
      )}
      {paragraph2 && (
        <>
          <div className={styles.header}>
            <InfoIcon />
            <h5>
              {paragraph2.title}
              {paragraph2.withDynamicData && slot}
            </h5>
          </div>
          <p>{paragraph2.messages[0]}</p>
        </>
      )}
      {paragraph3 && (
        <p>
          {paragraph3.messages[0]}
          {paragraph3.withDynamicData && (
            <strong>
              {paragraph3.messages[1]}
              {endTime}
              {paragraph3.messages[2]}
            </strong>
          )}
        </p>
      )}
      {paragraph4 && (
        <>
          <div className={styles.header}>
            <InfoIcon />
            <h5>{paragraph4.title}</h5>
          </div>
          <p className={styles.noBottomMargin}>
            {paragraph4.messages[0]}
            <ExternalLink
              link={paragraph4.linkUrl}
              text={paragraph4.linkText}
              analytics={paragraph4.linkAnalytics}
              className={styles.link}
              withIcon={false}
            />
            .
          </p>
        </>
      )}
    </div>
  );
};
